import { css } from '@compiled/react';

import { wacToken } from '@/libraries/design/foundations';

import { BlueShapes, OrangePurpleShapes } from './bar-svgs';

export type DesignRefreshBarBackgroundDesign = 'blueShapes' | 'orangePurpleShapes';

export interface UniformDesignRefreshBarProps {
	backgroundDesign?: DesignRefreshBarBackgroundDesign;
}

const UniformDesignRefreshBar = ({
	backgroundDesign = 'blueShapes',
}: UniformDesignRefreshBarProps) => {
	return (
		<div css={[containerCss]} className={backgroundDesign}>
			{backgroundDesign === 'orangePurpleShapes' ? <OrangePurpleShapes /> : <BlueShapes />}
		</div>
	);
};

const containerCss = css({
	position: 'relative',
	width: '100%',
	height: '16px',
	overflow: 'hidden',
	'&.blueShapes': {
		background: wacToken('color.extended.blue400'),
	},
	'&.orangePurpleShapes': {
		background: wacToken('color.extended.saffron200'),
	},
});

export default UniformDesignRefreshBar;
